import { useEffect, useState } from "react";

export function useTheme() {
  const [theme, setTheme] = useState(() => sessionStorage.getItem("vibez-theme") || "light");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    sessionStorage.setItem("vibez-theme", theme);
  }, [theme]);

  return [theme, setTheme];
}